function renderInlineMarkdown(text) {
  const parts = String(text || '').split(/(\*\*[^*]+\*\*)/g)
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) return <strong key={i}>{part.slice(2, -2)}</strong>
    return <span key={i}>{part}</span>
  })
}

function CodexBlockRenderer({ block }) {
  if (!block) return null

  if (block.type === 'divider') return <hr className="codex-block-divider" />
  if (block.type === 'heading') return <h3 className="codex-block-heading">{block.text}</h3>
  if (block.type === 'callout') return <div className="codex-block-callout">{renderInlineMarkdown(block.text)}</div>
  if (block.type === 'example_music') return <pre className="codex-block-example">{block.text}</pre>
  if (block.type === 'image' && block.url) {
    return (
      <figure className="codex-block-image-wrap">
        <img src={block.url} alt={block.caption || ''} className="codex-block-image" loading="lazy" />
        {block.caption ? <figcaption>{block.caption}</figcaption> : null}
      </figure>
    )
  }
  return <p className="codex-block-paragraph">{renderInlineMarkdown(block.text)}</p>
}

export default CodexBlockRenderer
